/**
 * 搜索中状态时渲染
 */

import React from 'react';
export default (function (props) {
  var locale = props.locale;
  return /*#__PURE__*/React.createElement("div", {
    className: "cn-address--search-loading-container cn-address-search-text"
  }, locale.searching);
});